import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  InputSignal,
  InputSignalWithTransform,
  numberAttribute,
  Signal,
} from '@angular/core';
import { GoalActivitiesSectionComponent } from 'app/features/goal/components/goal-activities-section/goal-activities-section.component';
import { GoalHeaderComponent } from 'app/features/goal/components/goal-header/goal-header.component';
import { PulseComponent } from '@kinomap-dev/ng-ui-lib/loaders';
import { ToolbarDockComponent } from 'app/shared/ui/toolbar-dock/toolbar-dock.component';
import { ToolbarGoalComponent } from 'app/features/goal/components/toolbar-goal/toolbar-goal.component';
import { ErrorStateComponent } from 'app/shared/ui/error-state/error-state.component';
import { GoalPageService } from 'app/features/goal/data-access/goal-page.service';
import { GoalStore } from 'app/features/goal/data-access/goal-store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GoalHeaderComponent,
    GoalActivitiesSectionComponent,
    ToolbarDockComponent,
    ToolbarGoalComponent,
    ErrorStateComponent,
    PulseComponent,
  ],
  providers: [GoalStore, GoalPageService],
  selector: 'app-goal',
  templateUrl: './goal.component.html',
  styleUrl: './goal.component.scss',
})
export class GoalComponent {
  readonly videoPosterUrl = 'goal.jpg';
  readonly videoUrl = 'https://d2z7yiz3wla4oq.cloudfront.net/videos/homepage_26.mp4';
  readonly goalPage: GoalPageService = inject(GoalPageService);
  readonly store: GoalStore = inject(GoalStore);

  //AstraZeneca
  isAstraZeneca: Signal<boolean> = computed(() => this.username().toLowerCase().includes('astrazeneca'));

  readonly username: InputSignal<string> = input.required<string>();
  readonly distance: InputSignalWithTransform<number, unknown> = input.required({
    transform: numberAttribute,
  });

  constructor() {
    effect(() => {
      this.goalPage.setContext(this.username(), this.distance());
    });
  }

  setActivitiesPage(page: number): void {
    const hasPageChanged: boolean = this.goalPage.setActivitiesPage(page);

    if (hasPageChanged) this.scrollToTop();
  }

  playHeroVideo(video: HTMLVideoElement): void {
    video.muted = true;
    void video.play().catch(() => undefined);
  }

  private scrollToTop(): void {
    window.scrollTo({ behavior: 'smooth', top: 0 });
  }
}
